import { Autocomplete, Chip, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useMemo } from 'react';

import { HourlyAccountUserGroupValidation } from '../../types';

interface ValidationMethodSelectProps {
	editing: boolean;
	value: HourlyAccountUserGroupValidation[];
	options: HourlyAccountUserGroupValidation[];
	onChange: (e, value) => void;
}
export const ValidationMethodSelect = ({ editing, value, options, onChange }: ValidationMethodSelectProps) => {
	const filteredOptions = useMemo(
		() =>
			options.map((option) => ({
				...option,
				id: null,
			})),
		[options],
	);

	if (editing) {
		return (
			<Autocomplete
				options={filteredOptions}
				value={value}
				multiple
				size='small'
				sx={{ width: '100%' }}
				filterSelectedOptions
				isOptionEqualToValue={(option, val) => option.validationMethod.id === val.validationMethod.id}
				getOptionLabel={(option) => option.validationMethod.text}
				getOptionKey={(option) => option.validationMethod.id}
				renderInput={(params) => (
					<TextField
						{...params}
						variant='standard'
						placeholder=''
						InputProps={{
							...params.InputProps,
							sx: {
								minHeight: '40px',
								'& .MuiAutocomplete-clearIndicator': {
									display: 'none',
								},
								'&::before': {
									borderBottom: 'none !important',
								},
								'&::after': {
									borderBottom: 'none !important',
								},
							},
						}}
					/>
				)}
				onChange={onChange}
			/>
		);
	}

	return (
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
			{value.map(({ validationMethod: { id, text } }) => (
				<Chip key={id} label={text} size='small' />
			))}
		</Box>
	);
};
